// extracted by mini-css-extract-plugin
export default {"container":"app_container__775-A","navbar":"app_navbar__2WfPN","logo":"app_logo__NhUkK","content":"app_content__-N4-u"};